import React from 'react';
import { Helmet } from 'react-helmet';
import Intro from './InforLN/IntroCarousel';
import LNOverview from './InforLN/LNOverview';
import LNCapabilities from './InforLN/LNCapabilities';
import LNIndustryCarousel from './InforLN/LNIndustryCarousel';
import LNFAQ from './InforLN/LNFAQ';
import LNCTA from './InforLN/CTA';

const InforLNComponent = () => {
  return (
    <>
      <Helmet>
        <title>PT KCS Tech | Infor LN ERP Solutions for Manufacturing</title>
        <meta
          name="description"
          content="PT KCS Tech delivers Infor LN ERP implementation, customization, integration, training, support, and optimization for manufacturing and distribution companies."
        />
        <meta
          name="keywords"
          content="PT KCS Tech, Infor LN ERP, Infor LN implementation, manufacturing ERP, Infor LN consulting, ERP customization, ERP integration, Infor LN support"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PT KCS Tech | Infor LN ERP Solutions" />
        <meta
          property="og:description"
          content="End-to-end Infor LN ERP services for manufacturing, supply chain, finance, quality, and service operations."
        />
        <meta
          property="og:image"
          content="https://ik.imagekit.io/kqumni8l2/Manufaturing-SamaConsulting.jpg?updatedAt=1758520973311"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PT KCS Tech | Infor LN ERP Solutions" />
        <meta
          name="twitter:description"
          content="Implementation, customization, integration, support, and optimization services for Infor LN ERP."
        />
        <meta
          name="twitter:image"
          content="https://ik.imagekit.io/kqumni8l2/Manufaturing-SamaConsulting.jpg?updatedAt=1758520973311"
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS Tech" />
      </Helmet>

      <div className="infor-ln-page min-h-screen font-satoshi" style={{ backgroundColor: '#FFFFFF' }}>
        <Intro />
        <LNOverview />
        <LNCapabilities />
        <LNIndustryCarousel />
        <LNFAQ />
        <LNCTA />
      </div>
    </>
  );
};

export default InforLNComponent;
